import {
  AutoCompleteAutomations,
  DateInput,
  FormEmojiTextInput,
  FormInput,
  ITicketAutomation,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalAxios } from "../../../../../../axios/axios-config";
import FormInformation from "../../../../../../components/FormInformation/FormInformation";
import { TAutomationReceivedRuleForm } from "../automationReceivedRuleSchema";
import { TFormType } from "@4uhub/lib4uhub/dist/types/components/Form/FormContainer/models";
import { BoardList } from "../../../../../../components/BoardList/BoardList";

const translationPath = "chatBot.page.automations.automationReceivedRules.";

export const BasicData = memo(
  ({
    ticketAutomation,
    type,
    code,
  }: {
    ticketAutomation: ITicketAutomation | null;
    type: TFormType;
    code?: number;
  }) => {
    const { t } = useTranslation();

    const { control, setValue } = useFormContext<TAutomationReceivedRuleForm>();

    const currentAutomation = useWatch({ name: "ticketAutomation", control });

    const params = useMemo(() => {
      return { TicketAutomationTypeCode: "2", Enable: true };
    }, []);

    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          display={"flex"}
          justifyContent={type === "create" ? "end" : "space-between"}
          alignItems={"center"}
        >
          {" "}
          {type === "update" && (
            <FormInformation
              label={t(translationPath + "code")}
              data={code?.toString() ?? "-"}
              minHeight={40}
            />
          )}
          <SwitchInput name="enable" label={t(translationPath + "enable")} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormInput
            name="name"
            label={t(translationPath + "name")}
            size="small"
            fullWidth
            autoFocus
          />
        </Grid>

        {ticketAutomation && (
          <Grid item xs={12} sm={6}>
            <FormInformation
              label={t(translationPath + "automation")}
              data={currentAutomation ? currentAutomation.name : "-"}
              minHeight={40}
            />
          </Grid>
        )}

        {!ticketAutomation && (
          <Grid item xs={12} sm={6}>
            <AutoCompleteAutomations
              name="ticketAutomation"
              params={params}
              axios={GlobalAxios}
              label={t(translationPath + "automation")}
              getOptionLabel={(option) => option.name}
              size="small"
              fullWidth
              excludeCodes={["7"]}
              onValueChange={(value) => {
                if (value?.code === "33") {
                  setValue("ticketChannelWhenFinished", null);
                  setValue("ticketChannelStepWhenFinished", null);
                  setValue("transferMessage", null);
                }
              }}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <DateInput
            name="initialDate"
            label={t(translationPath + "initial_date")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <DateInput name="endDate" label={t(translationPath + "end_date")} />
        </Grid>

        <BoardList
          label={t(translationPath + "when_error") ?? undefined}
          boardFieldName="ticketChannelWhenError"
          listFieldName="ticketChannelStepWhenError"
        />

        <Grid item xs={12}>
          <FormEmojiTextInput
            size="small"
            name="errorMessage"
            label={t(translationPath + "error_message")}
            autoFocus
            multiline
            rows={4}
            fullWidth
          />
        </Grid>

        {currentAutomation?.code !== "33" && (
          <>
            <BoardList
              label={t(translationPath + "when_finished") ?? undefined}
              boardFieldName="ticketChannelWhenFinished"
              listFieldName="ticketChannelStepWhenFinished"
            />

            <Grid item xs={12}>
              <FormEmojiTextInput
                size="small"
                name="transferMessage"
                label={t(translationPath + "transfer_message")}
                autoFocus
                multiline
                rows={4}
                fullWidth
              />
            </Grid>
          </>
        )}
      </>
    );
  },
);
